export const branding = [
    { id: -1, name: 'Select branding' },
    { id: 1, name: 'Branded' },
    { id: 2, name: 'Non-branded' },
];